import type RedeEnsino from "../types/redesEnsino";

const redesEnsino: RedeEnsino[] = [
  {
    value: 2,
    label: "Estadual",
    text: "Estadual",
  },
  {
    value: 3,
    label: "Municipal",
    text: "Municipal",
  },
];

export { redesEnsino };
